// src/components/ModeloSpecs/ModeloSpecs.jsx
import React, { useEffect, useRef } from 'react';
import styles from './ModeloSpecs.module.scss';

const ModeloSpecs = ({ specs }) => {
  const specRef = useRef([]); // refs to each spec element

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add(styles.visible);
          }
        });
      },
      { threshold: 0.2 }
    );
    specRef.current.forEach(el => {
      if (el) observer.observe(el);
    });
    return () => {
      specRef.current.forEach(el => {
        if (el) observer.unobserve(el);
      });
    };
  }, []);

  const firstThreeSpecs = specs.slice(0, 3);

  return (
    <div className={styles.modeloSpecsContainer}>
      <h3 className={styles.modeloSpecsTitle}>Principales ventajas</h3>
      <div className={styles.modeloSpecs}>
        {firstThreeSpecs.map((spec, idx) => (
          <div
            key={idx}
            className={styles.modeloSpec}
            ref={el => (specRef.current[idx] = el)}
          >
            <div className={styles.modeloSpecValue}>{spec.value}</div>
            <div className={styles.modeloSpecName}>{spec.name}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ModeloSpecs;
